import { Navigate, useLocation } from 'react-router-dom';
import { useContext } from 'react';
import { AuthContext } from '../context/AuthContext';

// Map routes to required permission modules
const ROUTE_PERMISSIONS = {
  '/dashboard/trends': 'trends',
  '/dashboard': 'dashboard',
  '/finance': 'finance_budgets',
  '/hr': 'hr_overview',
  '/sales': 'sales_overview',
  '/support': 'support_overview',
  '/people': 'hr_overview',
  '/alerts': 'alerts',
  '/settings/users': 'users',
  '/settings/roles': 'users',
  '/settings/connect-crm': 'settings',
  '/settings/connect-hrms': 'settings',
  '/settings/connect-fixdesk': 'settings',
  '/settings/targets': 'settings',
  '/projects': 'projects',
};

const ProtectedRoute = ({ children }) => {
  const token = sessionStorage.getItem('token');
  const location = useLocation();
  const { hasPermission } = useContext(AuthContext);

  if (!token) {
    return <Navigate to="/" replace />;
  }

  // Check module permission for the current route
  const requiredModule = Object.entries(ROUTE_PERMISSIONS).find(
    ([path]) => location.pathname === path || location.pathname.startsWith(path + '/')
  )?.[1];

  if (requiredModule && !hasPermission(requiredModule, 'view')) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default ProtectedRoute;
